import { render } from "./AddressPrintingPage.vue?vue&type=template&id=f10e7e9e"
import script from "./AddressPrintingPage.vue?vue&type=script&lang=js"
export * from "./AddressPrintingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__